// services/podioService.js
import axiosInstance from './AxiosConfig';

/**
 * Obtiene el podio para una TorneoCategoria dada.
 *
 * @param {number|string} idTorneoCategoria
 * @returns {Promise<Object[]>} — Array de objetos podio[{ id_podio, id_equipo, posicion, equipo:{…} }, …]
 */
export const fetchPodioByTorneoCategoriaAPI = async (idTorneoCategoria) => {
  try {
    const resp = await axiosInstance.get(`/api/podios/${idTorneoCategoria}`);
    return resp.data.podio; 
  } catch (error) {
    console.error('Error al obtener el podio:', error);
    throw error;
  }
};

/**
 * Genera el podio completo desde la tabla final de una TorneoCategoria.
 *
 * @param {number|string} idTorneoCategoria
 * @param {{ modo?: 'original'|'ajustada'|'normalizada' }} options
 * @returns {Promise<Object[]|Object>} Podio generado o respuesta del backend.
 */
export const generatePodioDesdeTablaFinalAPI = async (
  idTorneoCategoria,
  { modo = "ajustada" } = {}
) => {
  try {
    const resp = await axiosInstance.post(
      `/api/podios/${idTorneoCategoria}/desde-tabla-final`,
      { modo }
    );
    return resp.data?.podio ?? resp.data;
  } catch (error) {
    console.error('Error al generar el podio desde la tabla final:', error);
    throw error;
  }
};
